"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCD = function FlagCD(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H189.29L-193,75.74V89.86L213.7-120.5a6.94,6.94,0,0,0-4.16-1.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94,146.36h20.24L216.6-51.38V-65.5L-190.09,144.85a6.86,6.86,0,0,0,4.15,1.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M213.7-120.5-193,89.86V139.3a6.91,6.91,0,0,0,2.91,5.55L216.6-65.5v-49.44a7,7,0,0,0-2.9-5.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.91-94.24l10.18,30.51,32.16.25a1.87,1.87,0,0,1,1.1,3.38L-101.34-41l9.69,30.66a1.87,1.87,0,0,1-2.87,2.09l-26.16-18.7-26.16,18.7a1.87,1.87,0,0,1-2.88-2.09L-140-41l-25.87-19.1a1.87,1.87,0,0,1,1.1-3.38l32.16-.25,10.17-30.51a1.87,1.87,0,0,1,3.55,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCD;
exports["default"] = _default;